import styled from '@emotion/styled';
import { ReactComponent as DownloadIcon } from 'assets/icons/downloadB2b.svg';

export const SectionTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin: 40px 0 16px 0;
`;

export const TableWrapper = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    background: white;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const TableHeader = styled.th`
    padding: 12px 16px;
    text-align: left;
    font-weight: 500;
    color: #6b7280;
    background: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    font-size: 14px;
`;

export const TableRow = styled.tr`
    border-bottom: 1px solid #f3f4f6;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #f9fafb;
    }
`;

export const TableCell = styled.td`
    padding: 16px;
    color: #111827;
`;

export const PaidBadge = styled.span`
    background: #d1fae5;
    color: #065f46;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
`;

export const FailedBadge = styled.span`
    background: #fee2e2;
    color: #991b1b;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
`;

export const PendingBadge = styled.span`
    background: #fef3c7;
    color: #92400e;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
`;

export const DownloadLink = styled.button`
    display: flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: none;
    color: #6366f1;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.2s;

    &:hover {
        text-decoration: underline;
    }

    &:disabled {
        color: #9ca3af;
        cursor: not-allowed;
    }
`;

export const DownloadIconStyled = styled(DownloadIcon)`
    width: 16px;
    height: 16px;
    path {
        fill: #6366f1;
    }
`;

export const EmptyState = styled.div`
    padding: 40px;
    text-align: center;
    color: #6b7280;
`;
